import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { deviceListMsg, deviceListsMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n/index.js';
import { getCompanyName } from '../../../../../common/utils/accountUtils.js';
import { getDeviceListsTabPath } from '../../../../../common/utils/deviceListTabsUtilsCoCo.js';
import { BreadCrumbs } from '../../../../../components/BreadCrumbs/index.js';
import { DetailsWrapper } from '../../../../../components/DetailsWrapper/index.js';
import { DeviceListDetailsCoCo } from '../../../../../components/DeviceListDetailsCoCo/DeviceListDetailsCoCo.js';
import { useAuth } from '../../../AuthProvider.js';
import type { DeviceListDetailsLoaderDataCoCo } from '../../../../../common/loaders.js';

export const CompanyInfoDeviceListDetailsPageCoCo = () => {
  const data = useLoaderData() as DeviceListDetailsLoaderDataCoCo;
  const { deviceList } = data;
  const { authenticatedUser } = useAuth();
  const name = deviceList.name ?? '';

  return (
    <DetailsWrapper
      classes={['of-device-list-details-coco']}
      detailsTop={
        <BreadCrumbs
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            {
              name: t.COBB(deviceListsMsg),
              path: deviceList.accountMdmId
                ? getDeviceListsTabPath(deviceList.accountMdmId)
                : paths.COMPANY_INFO_CATALOGS,
            },
            { name },
          ]}
        />
      }
      id={`device-list-${deviceList.uuid}`}
      headingTop={t.Z0HF(deviceListMsg)}
      heading={name}
      headingBottom={getCompanyName(authenticatedUser, deviceList.accountMdmId)}
      heroPicto="catalog"
    >
      <DeviceListDetailsCoCo {...data} />
    </DetailsWrapper>
  );
};
